<template>
  <div class="policy">
    <h2>NothingDB隐私政策</h2>
    <p>
      NothingDB收集、使用、维护和披露来自NothingDB商务平台的用户（每一个“用户”）收集的资讯.网站（“网站”），以及作为社交媒体内容的协力厂商内容作者的个人（“社交媒体作者”）。本隐私政策适用于本网站以及我们提供的所有产品和服务。
    </p>
    <h3>个人身份资讯</h3>
    <p>
      用户如果您希望访问本网站的某些受限部分或要求接收行销资料，则可能需要您成为注册用户，并向NothingDB提交以下类型的个人资讯：您的姓名，电子邮寄地址，完整用户名称和时区。但是，用户可以匿名访问我们的网站。仅当用户自愿向我们提交此类资讯时，我们才会收集使用者的个人身份资讯。用户可以随时拒绝提供个人身份资讯，除非它可能封锁他们从事某些与网站相关的活动。
    </p>
    <h3>社交媒体作者</h3>
    <p>
      NothingDB接收来自Facebook等协力厂商的个人数据，以满足我们为客户服务的合法利益。我们完全遵守他们的公共条款和条件，并信任他们通过其强大的隐私政策保护社会媒体作者。
      NothingDB收集、使用、处理和存储在上面列出的社交媒体平台上公开发佈的资讯，如：
    </p>
    <h3>Facebook</h3>
    <p>
      NothingDB可能允许您将Facebook页面，个人资料，组或事件连接到您的NothingDB帐户，在这种情况下，我们将访问来自Facebook的有关您帐户的某些资讯。特别是，我们可能会收集个人资料影像，显示名称，用户名/页面ID或个人资料ID，访问权杖，已发送的帖子。在适用法律允许的范围内，这包括您的帖子和参与度数据的内容（例如点击率，喜欢，转发，展示次数以及常规参与度计数）。NothingDB仅将这些数据用于为您提供您期望的服务，并且不会与任何协力厂商共用。
      用户和社交媒体作者的权利任何时候，您都可以联系wbj@asiassxkj.com并要求我们：
    </p>
    <p>·纠正个人数据</p>
    <p>
      ·为您提供个人数据的副本·永久删除我们收集的任何个人或非个人数据（如cookie）
    </p>
    <p>·拒绝与市场行销相关的任何使用非个人身份资讯</p>
    <p>
      我们可能会在用户与我们的网站互动时收集非个人身份资讯。非个人身份资讯可能包括浏览器名称、电脑类型和用户连接到我们网站的科技资讯，例如作业系统和使用的互联网服务提供者以及其他类似资讯。
    </p>
    <h3>Web浏览器cookie</h3>
    <p>
      我们的网站可能使用“cookies”来增强用户体验。用户的web浏览器会将cookie放在硬盘上，以保持记录的目的，有时还可以跟踪有关它们的资讯。用户可以选择将其web浏览器设定为拒绝cookie，或在发送cookie时提醒您。如果他们这样做，请注意，网站的某些部分可能无法正常工作。当您浏览NothingDB时，广告cookie将放在您的电脑上，以便我们能够了解您感兴趣的内容。然后，我们的广告合作伙伴可以根据您以前与NothingDB的互动，向您展示针对其他网站的重定向广告。我们合作伙伴使用的科技不收集个人资讯，如您的姓名、电子邮寄地址、邮寄地址或电话号码。您可以访问错误！超连结引用无效。选择退出我们合作伙伴的目标广告。您有权联系wbj@asiassxkj.com并要求我们删除连结到您和您的线上活动的任何cookie。
    </p>
    <h3>我们如何使用收集的资讯</h3>
    <p>用户NothingDB可能出于以下目的收集和使用用户的个人资讯：</p>
    <p>-改善客户服务</p>
    <p>您提供的资讯有助于我们更高效地响应您的客户服务请求和支持需求。</p>
    <p>
      -个性化用户体验我们可能使用汇总中的资讯来了解我们的用户作为一个群体如何使用我们网站上提供的服务和资源。
    </p>
    <p>-改善我们的网站</p>
    <p>我们可能会使用您提供的迴响来改进我们的产品和服务。</p>
    <h3>社交媒体作者权利</h3>
    <p>我们为客户提供服务根据我们合法收集和处理的数据。</p>
    <p>您的资讯也可通过以下管道使用：</p>
    <p>·让我们的客户更多地了解他们的品牌、客户和竞争对手；</p>
    <p>·改善我们的服务。</p>
    <p>我们如何保护您的资讯</p>
    <p>
      我们採取适当的数据收集、存储和处理做法和安全措施，以防止未经授权的访问、更改、披露或销毁您的个人资讯、用户名、密码、交易资讯和资料存储在我们的网站上。
    </p>
    <p>
      按照我们公司的价值观和GDPR法律，您将在不太可能发生数据洩露的情况下立即收到通知。
    </p>
    <h3>分享您的个人资讯</h3>
    <p>
      我们不会向他人出售、交易或出租用户的个人身份资讯。出于上述目的，我们可能会与我们的业务合作伙伴、受信任的关联公司和广告客户共用未与访问者和用户的任何个人身份资讯相关的一般汇总人口统计资讯。我们可能会使用协力厂商服务提供者来帮助我们运营我们的业务和网站，或代表我们管理活动，例如发送新闻稿或调查。我们可能会将您的资讯与这些协力厂商共用，但前提是您已给予我们许可。社交媒体作者我们以个人身份资讯中概述的管道与客户共用您的数据。
    </p>
    <h3>本隐私政策的更改</h3>
    <p>
      NothingDB有权随时更新本隐私政策。我们鼓励用户经常查看此页面以了解任何更改，以便随时了解我们如何帮助保护我们收集的个人资讯。您确认并同意，您有责任定期查看本隐私政策并了解修改情况。
    </p>
    <h3>您接受这些条款</h3>
    <p>
      使用本网站即表示您接受本政策。如果您不同意此政策，请不要使用我们的网站。您在发佈本政策更改后继续使用本网站将视为您接受这些更改。
    </p>
    <div class="footer">
      <p>
        &copy;<span>{{ this.host }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    host() {
      return window.location.host;
    },
  },
};
</script>

<style lang="less" scoped></style>
